import * as React from 'react';
import { format } from 'date-fns';
import { Prompt } from 'react-router';
import { reduxForm } from 'redux-form';
import { Card } from 'material-ui/Card';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { compose, withProps } from 'recompose';
import { compact } from 'lodash';
import Button from '@inqool/uas-web-core/es/components/controls/Button';

import { entityDetailEnhancer } from '@components/hoc/entityDetailEnhancer';

import { Tabs } from '@components/tabs';

import { getRepair } from '@modules/repairs/_repairsActions';
import * as T from '@modules/repairs/_repairsTypes';
import { RepairsCreateFormBasic } from '@modules/repairs/RepairsCreateFormBasic';
import { RepairsHistoriesForm } from '@modules/repairs/RepairsHistoriesForm';
import { RepairType } from '@modules/repairs/_repairsEnums';
import { RepairsInvoicesForm } from '@modules/repairs/RepairsInvoicesForm';

export const enhance = compose<T.RepairsFormProps, T.Outter>(
  entityDetailEnhancer<T.RepairsEnhancerProps<T.Repair>, T.Repair>({
    getEntity: getRepair,
    defaultEntity: {}
  }),
  breadcrumbs(({ entity }) => [
    { label: 'Opravy', to: '/repairs' },
    { label: entity && entity.id ? 'Nový záznam' : 'Upravit záznam' }
  ]),
  withProps<{}, T.RepairsProps>(({ entity }) => ({
    initialValues: {
      ...entity
    },
    maxYear: format(new Date(), 'YYYY')
  })),
  reduxForm({
    form: 'module-Repairs'
  })
);

export const View: React.SFC<T.Outter & T.RepairsFormProps> = ({
  handleSubmit,
  change,
  entity,
  closeItem,
  ...props
}) => (
  <div>
    <Prompt
      when={props.dirty && !props.submitSucceeded && !props.submitting}
      message="Vaše změny nebyly uloženy, přesto odejít?"
    />
    <form className="layout" onSubmit={handleSubmit}>
      <Card>
        <Tabs
          items={compact([
            {
              label: 'Editace',
              style: { minWidth: 150 },
              content: (
                <RepairsCreateFormBasic
                  change={change}
                  type={entity && entity.type}
                  disabled={!entity || entity.locked}
                />
              )
            },
            { label: 'Historie', style: { minWidth: 150 }, content: <RepairsHistoriesForm /> },
            entity && entity.type === RepairType.REPAIR
              ? {
                  label: 'Faktury',
                  style: { minWidth: 150 },
                  content: (
                    <RepairsInvoicesForm
                      disabled={entity.locked}
                      type={entity && entity.type}
                      onChange={change}
                      value={entity.invoices}
                    />
                  )
                }
              : null
          ])}
        />

        <Button
          type="submit"
          label="Uložit a zavřít"
          primary={true}
          style={{ margin: '16px 0 16px 16px' }}
          disabled={entity && entity.locked}
        />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
      </Card>
    </form>
  </div>
);

export const RepairsForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/repairs/RepairsForm.tsx